import service from '@/store/services/settings/activity-workplace-service';

const state = {
    list: {},
    activityWorkplace: {},
    meta: {},
    url:null
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, activityWorkplace) => {
        state.activityWorkplace = activityWorkplace;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    },
    SET_URL: (state, url) => {
        state.url = url;
    }
};

const actions = {
    list ({ commit, dispatch }, params) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(activityWorkplace => {
                commit('SET_RESOURCE', activityWorkplace);
            });
    },

    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(activityWorkplace => {
                commit('SET_RESOURCE', activityWorkplace);
            });
    },

    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((activityWorkplace) => {
                commit('SET_RESOURCE', activityWorkplace);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((activityWorkplace) => {
                commit('SET_RESOURCE', activityWorkplace);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};
const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    activityWorkplace: state => state.activityWorkplace,
    dropdown: (state) => {
        return state.list.map(activityWorkplace => ({
            id: activityWorkplace.id,
            name: activityWorkplace.request_type
        }));
    },
    url: state => state.url,
};

const activityWorkplaces = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default activityWorkplaces;
